<template>
  <div class="chat-message-translate-inline">
    <div class="translate-head">
      <span class="translate-label">{{ labelText }}</span>
    </div>
    <div v-if="state.loading" class="translate-body translate-body--muted">翻译中…</div>
    <div v-else-if="state.error" class="translate-body translate-body--error">{{ state.error }}</div>
    <div v-else class="translate-body">
      <span class="translate-text" v-html="htmlText"></span>
    </div>
  </div>
</template>

<script>
/**
 * 气泡内「译文」条：样式对齐引用消息块，由 ChatBox 写入接口结果后通过 props 展示。
 */
export default {
  name: "ChatMessageTranslateInline",
  props: {
    state: {
      type: Object,
      required: true
    }
  },
  computed: {
    labelText() {
      const lang = this.state.langLabel;
      return lang ? `译文（${lang}）` : "译文";
    },
    htmlText() {
      const raw = this.state.text || "";
      return this.$emo.transform(this.$str.html2Escape(raw), "emoji-small");
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-message-translate-inline {
  background: #eee;
  padding: 8px;
  border-radius: 8px;
  font-size: var(--im-font-size-smaller);
  color: var(--im-text-color-light);
  text-align: left;
  max-width: 100%;
  box-sizing: border-box;

  .translate-head {
    margin-bottom: 4px;
  }

  .translate-label {
    font-weight: 600;
    font-size: var(--im-font-size-smaller);
    color: var(--im-text-color);
  }

  .translate-body {
    line-height: 1.45;
  }

  .translate-body--muted {
    color: #94a3b8;
  }

  .translate-body--error {
    color: var(--im-color-danger, #f56c6c);
  }

  .translate-text {
    display: inline-block;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: left;
  }
}
</style>
